export default __webpack_public_path__ + "static/media/image-placeholder-unabacus.533ec4dc.jpg";